/* unplugin-vue-components disabled */import { render } from "./chat-header.vue?vue&type=template&id=4ad22dda&scoped=true"
import script from "./chat-header.vue?vue&type=script&lang=js"
export * from "./chat-header.vue?vue&type=script&lang=js"

import "./chat-header.vue?vue&type=style&index=0&id=4ad22dda&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad22dda"],['__file',"src/pages/chats/chat-header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ad22dda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ad22dda', __exports__)) {
    api.reload('4ad22dda', __exports__)
  }
  
  module.hot.accept("./chat-header.vue?vue&type=template&id=4ad22dda&scoped=true", () => {
    api.rerender('4ad22dda', render)
  })

}


export default __exports__